import "features";

import { FaroErrorBoundary } from "@grafana/faro-react";
import { OpenFeatureProvider } from "@openfeature/react-sdk";
import { BrowserRouter } from "react-router-dom";

import Routes from "@/routes";

const App = () => (
  <OpenFeatureProvider>
    <BrowserRouter>
      <FaroErrorBoundary fallback={<h2>Something went wrong</h2>}>
        <Routes />
      </FaroErrorBoundary>
    </BrowserRouter>
  </OpenFeatureProvider>
);

export default App;
